import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { ComingSoon } from "@/components/ComingSoon";

export default function Boutique() {
  const { locale } = useLang();
  const isFr = locale === "fr";
  return (
    <ComingSoon
      testId="page-boutique"
      title={isFr ? "Boutique d'affiliation" : "Affiliate Shop"}
      blurb={isFr
        ? "À très vite pour découvrir mes recommandations et mes produits — matériel de cuisine, fibres naturelles et outils de soutien vibratoire."
        : "See you very soon to discover my recommendations and products — kitchen equipment, natural fibres and vibrational support tools."}
    />
  );
}
